import React, { useEffect, useState } from "react";
import { Col, OverlayTrigger, Row, Table } from "react-bootstrap";
import PopoverB from "react-bootstrap/Popover";
import PopoverBody from "react-bootstrap/PopoverBody";
import { BsDownload } from "react-icons/bs";
import { FaSearch } from "react-icons/fa";
import { mapper } from "../../utils/mapper";
import { connect, useSelector } from "react-redux";
import PropTypes from "prop-types";
import {
  immobilizeNonComIssue,
  immobilizeReasonData,
  immobilizevehicleStatusOptions,
} from "../../utils/constants";
import BaseModal from "../shared/modals/BaseModal/BaseModal";
import Pagination from "../helpers/hoc/paginator/Pagination";
import MultiSelect from "../helpers/hoc/mult-select/MultiSelect";
import SingleSelect from "../helpers/hoc/single-select/SingleSelect";
import MapAdddressByLocation from "../helpers/hoc/latlong-to-address-map/MapAddressByLocation";
import {
  ExportImmobilize,
  fetchImmobilize,
  fetchReasonImmobilize,
} from "../../store/actions/immobilize/Immobilize";
import { processChangeWithDebounce } from "../../utils/common-methods";
import NoRecordFound from "../helpers/hoc/noRecordFound";
import styleImmobilizeTabs from "./ImmobilizeTab.module.css";
import Loader from "../helpers/hoc/loader/Loader";
import VehicleNRNTooltip from '../helpers/hoc/common-components/vehicle-nrn'


const ImmobilizeTab = ({
  // state
  subscribedByCI,
  immobilizeListData,
  selectedTab,

  // action
  fetchImmobilize,
  ExportImmobilize,
  fetchReasonImmobilize,
}) => {

  const vehicleData = subscribedByCI?.filter(v => v.oem === 'Bounce')
  const mappedOptions = mapper.mapVehicleDataOptions(vehicleData);
  const vehicleStatusOptionsList = immobilizevehicleStatusOptions?.map((d) => ({
    label: d.label,
    value: d.value,
  }));
  const immobilizeNonComIssueList = immobilizeNonComIssue?.map((d) => ({
    label: d.label,
    value: d.value,
  }));
  const immobilizeReasonDataList = immobilizeReasonData?.map((d) => ({
    label: d.label,
    value: d.value,
  }));

  const OthersData = [
    { id: 1, message: "Location not received" },
    { id: 2, message: " SoC received is 0" },
    { id: 3, message: "CAN data received is 0" },
    { id: 4, message: "Location, SoC, CAN & ODO Meter data received are 0" },
  ];

  const initialFieldValues = {
    registrationNumber: [],
    location: [],
    status: [],
    nonComIssue: [],
  };

  // States

  const ITEMS_PER_PAGE = 8;
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState();
  const [immobilizeModal, setImmobilizeModal] = useState(false);
  const [selectedReasonImmobilize, setSelectedReasonImmobilize] =
    useState(null);
  const [reasonOtherInput, setReasonOtherInput] = useState();
  const [showInputField, setShowInputField] = useState(false);
  const [formData, setFormData] = useState(initialFieldValues);
  const [showPopup, setShowPopup] = useState(false);
  const [coordinate, setCoordinate] = useState();
  const [immobilizieImei, setImmobilizieImei] = useState("");

  const isLoading = useSelector((state) => state.loader.isLoading);

  const handleChangeReasonImmobilize = (e) => {
    setReasonOtherInput(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  function renderTooltip(props) {
    return (
      <PopoverB className={styleImmobilizeTabs.popover}>
        <PopoverBody className={styleImmobilizeTabs.popoverBody}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <div>
              <ul
                style={{
                  listStyleType: "none",
                  padding: 0,
                  background: "#22046B",
                  color: "#FFFFFF",
                  fontSize: "12px",
                }}
              >
                {OthersData.map((location) => (
                  <li
                    key={location.id}
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      marginBottom: "10px",
                    }}
                  >
                    <span
                      style={{
                        marginRight: "5px",
                      }}
                    >
                      {location.id}
                    </span>
                    <span
                      style={{
                        width: "190px",
                        textAlign: "left",
                      }}
                    >
                      {location.rm}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </PopoverBody>
      </PopoverB>
    );
  }

  const RowButton = ({
    renderTooltip,
    integrationBy,
    intergrationDate,
    integrationTime,
  }) => (
    <OverlayTrigger
      placement="top"
      delay={{ show: 0, hide: 0 }}
      overlay={renderTooltip({
        parameter1: integrationBy,
        parameter2: intergrationDate,
        parameter3: integrationTime,
      })}
    >
      <button style={{ background: "transparent", marginLeft: "5px" }}>
        <img src="/images/infoIconMobilize.svg" alt="info" />
      </button>
    </OverlayTrigger>
  );

  const togglePopup = () => {
    setShowPopup((prevState) => !prevState);
  };
  const handleMapCoOrdinateClick = (event) => {
    setShowPopup(true);
    setCoordinate(event);
  };

  // Blank  dropdowns  states
  useEffect(() => {
    setFormData(initialFieldValues);
    setReasonOtherInput("");
    setSelectedReasonImmobilize(null);
    setSearchTerm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTab]);

  // UseEffect for thi vehicle Registration no.

  const handleOnChange = ({ name = "", value = "" }) => {
    setFormData((prevFormData) => {
      const newFormData = {
        ...prevFormData,
        [name]: value,
      };
      setCurrentPage(1)
      return newFormData;
    });
  };

  const fetchImmobilizeData = () => {

    fetchImmobilize({
      searchKey: searchTerm,
      pageIndex: currentPage,
      pageSize: ITEMS_PER_PAGE,
      registrationNumber: formData.registrationNumber?.map((x) => x.label),
      location: formData.location?.map((x) => x.label),
      status: formData.status?.map((x) => x.label),
      nonComIssue: formData.nonComIssue?.map((x) => x.value),
    });
  };

  useEffect(() => {
    if (selectedTab === "immobilize") {
      fetchImmobilizeData({ ...formData });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm, currentPage,formData]);

  // eslint-disable-next-line no-unused-vars

  const handleOpenImmobilize = (imei) => {
    setImmobilizeModal(true);
    setImmobilizieImei(imei);
   
  };

  const handleCloseImmobilize = () => {
    setImmobilizeModal(false);
    setReasonOtherInput("");
    setSelectedReasonImmobilize(null);
    setShowInputField(false);
  };

  // handle changes for other

  const onSelectionChangeOther = (value) => {
    setSelectedReasonImmobilize(value);
    if (value.label === "Others") {
      setShowInputField(true);
    } else {
      setShowInputField(false);
    }
  };

  const exportToExcel = () => {
    ExportImmobilize({
      data: {
        searchKey: searchTerm,
        pageIndex: currentPage,
        pageSize: ITEMS_PER_PAGE,
        registrationNumber: formData.registrationNumber?.map((x) => x.label),
        location: formData.location?.map((x) => x.label),
        status: formData.status?.map((x) => x.label),
        nonComIssue: formData.nonComIssue?.map((x) => x.label),
      },
    });
  };

  const handlereasonImmobilizeUpdate = async () => {
    
   await fetchReasonImmobilize({
      data: {
        reasonType: selectedReasonImmobilize?.value,
        reasonMessage: reasonOtherInput,
        imei: immobilizieImei,
        command: "Immobilze",
      },
    });

    fetchImmobilizeData({ ...formData });
    setSearchTerm("");
    setImmobilizeModal(false);
  };

  // Status background or color  for immobilize

  function getStatusClass(status) {
    if (status === "Live") return styleImmobilizeTabs["immobilize-live-status"];
    if (status === "Non Com")
      return styleImmobilizeTabs["immobilize-non-com-status"];
    if (status === "Charging")
      return styleImmobilizeTabs["immobilize-charging-status"];
    if (status === "Parked")
      return styleImmobilizeTabs["immobilize-parked-status"];
    if (status === "Non Communication")
      return styleImmobilizeTabs["immobilize-communication-status"];
    if (status === "Idle") return styleImmobilizeTabs["immobilize-idle-status"];
    return "";
  }

  // Status background or color  for immobilize command

  function getCommandStatusClass(status) {
    if (status === "Immobilized")
      return styleImmobilizeTabs["command-immobilize-immobilize-status"];
    if (status === "Immobilizing Pending")
      return styleImmobilizeTabs["command-immobilize-pending-status"];
    if (status === "NA")
      return styleImmobilizeTabs["command-immobilize-pending-status"];
    if (status === "Command Not Received")
      return styleImmobilizeTabs["command-immobilize-notRecive-status"];
    if (status === "Mobilized")
      return styleImmobilizeTabs["command-immobilize-mobilize-status"];
    return "";
  }

  function getStatus(deviceResponse) {
    if (deviceResponse.includes("INFINITY")) {
      return "Immobilized";
    } else {
      return "Mobilized";
    }
  }

  const DataRow = ({ recent, index, val }) => (
    <tr style={{verticalAlign:'middle'}}>
      {/* <td>{recent?.rn}</td> */}
      <td>
        {recent?.rn}
        {recent?.nrn ?
        <VehicleNRNTooltip
        parameter1 = {recent.nrn}
        />
        : " "}
        </td>
      <td> {recent.oem + " " + recent.mdl}</td>
      <td>{recent?.csp }kmph</td>
      <td>{recent?.gsp}kmph</td>
      <td>
        <img
          style={{ cursor: "pointer" }}
          src="/images/locationImobilizeIcon.svg"
          alt="locatin"
          onClick={(event) =>
            handleMapCoOrdinateClick({
              lat: parseFloat(recent?.lt),
              lng: parseFloat(recent?.lng),
            })
          }
          data-testid={`unresolved-gps-button-${recent?.rn}`}
        />
      </td>

      <td className="mt-3">
        <button
          style={{ cursor: "auto" }}
          className={getStatusClass(recent?.vs)}
        >
           {recent?.vs === "Non Communication" ? "Non Com" : recent?.vs}
        </button>
      </td>
      <td>{recent?.issue ? recent?.issue : "_ _ _ _"}</td>
      <td>
        {" "}
        <button
          className={styleImmobilizeTabs.immobilizeActionBtn}
          data-testid={`view-button-${index}`}
          onClick={() => handleOpenImmobilize(recent.imei)}
        >
          Immobilize
        </button>
      </td>
      <td>
        <button
          style={{ cursor: "auto" }}
          className={getCommandStatusClass(getStatus(recent?.deviceResponse ))}
        >
        { recent?.deviceResponse ? getStatus(recent?.deviceResponse ):  "NA"}
        </button>
      </td>
      <td>
        <button
          style={{ cursor: "auto" }}
          className={styleImmobilizeTabs.reasonBtn}
          data-testid={`view-button-${index}`}
        >
          {recent?.irt}
          {recent.Reason === "Others" && (
            <RowButton renderTooltip={renderTooltip} />
          )}
        </button>
      </td>
    </tr>
  );

  return (
    <>
      <Row>
        <Col xs={2}>
          <MultiSelect
            valueContainerWidthInPx="200px"
            valueContainerMaxWidthInPx="200px"
            menuListPaddingX="px-2"
            placeholderAlignment="flex-start"
            okButtonPaddingEnd="pe-2"
            optionPosition="ps-2 justify-content-start"
            placeholder="Registration No."
            placeholderColor="#1F2A5D"
            isMultiSelect={true}
            indicatorSeparatorDisplay="none"
            minHeight="45px"
            valueContainerColor="#1F2A5D"
            customBackgroundColor="#EFF3F8"
            options={mappedOptions.registrationNumber}
            selectedOptions={formData.registrationNumber}
            setSelectedOptions={(data) =>
              handleOnChange({ name: "registrationNumber", value: data })
            }
            data-testid="vehicle-filter"
          />
        </Col>

        <Col xs={2}>
          <MultiSelect
            valueContainerWidthInPx="200px"
            valueContainerMaxWidthInPx="200px"
            menuListPaddingX="px-2"
            okButtonPaddingEnd="pe-2"
            placeholderAlignment="flex-start"
            placeholderColor="#1F2A5D"
            optionPosition="ps-2 justify-content-start"
            placeholder="Status"
            isMultiSelect={true}
            indicatorSeparatorDisplay="none"
            minHeight="45px"
            valueContainerColor="#797694"
            customBackgroundColor="#EFF3F8"
            options={vehicleStatusOptionsList}
            selectedOptions={formData.status}
            setSelectedOptions={(data) =>
              handleOnChange({ name: "status", value: data })
            }
            data-testid="status-filter"
          />
        </Col>
        <Col xs={2}>
          <MultiSelect
            valueContainerWidthInPx="200px"
            valueContainerMaxWidthInPx="200px"
            menuListPaddingX="px-2"
            okButtonPaddingEnd="pe-2"
            placeholderColor="#1F2A5D"
            optionPosition="ps-2 justify-content-start"
            placeholder="Non Com Issue"
            placeholderAlignment="flex-start"
            isMultiSelect={true}
            indicatorSeparatorDisplay="none"
            minHeight="45px"
            valueContainerColor="#797694"
            customBackgroundColor="#EFF3F8"
            options={immobilizeNonComIssueList}
            selectedOptions={formData.nonComIssue}
            setSelectedOptions={(data) =>
              handleOnChange({ name: "nonComIssue", value: data })
            }
            data-testid="nonComIssue-filter"
          />
        </Col>
      </Row>
      <div className="d-flex justify-content-between">
        <div
          className="search-bar-div search-input mt-3 "
          style={{ width: "15%" }}
        >
          <FaSearch className="vob-search-icon" />
          <input
            onChange={(e) => {
              processChangeWithDebounce(e, setSearchTerm, setCurrentPage);
            }}
            className="vob-search-input search-input"
            placeholder="Search"
            data-testid="unresolved-search-input"
          />
          <div></div>
        </div>

        <div className=" d-flex  me-3 mt-4">
          <button
            onClick={() => {
              fetchImmobilizeData();
            }}
            className={styleImmobilizeTabs.dwnRefresh}
            data-testid="unresolved-export-button"
          >
            Refresh <img src="/images/refreshIcon.svg" alt="refreshIcon" />
          </button>

          <button
            onClick={() => {
              exportToExcel("Open");
            }}
            className={"dwn-btn"}
            data-testid="unresolved-export-button"
          >
            <BsDownload style={{width:'22px',height:'22px'}} />
          </button>
        </div>
      </div>
      {immobilizeListData?.result?.length ? (
      

        <div className="bg-white position-relative px-2 py-3 mt-3" style={{
          boxShadow: '0px 3px 6px #00000029',
          border:'1px solid rgba(0, 0, 0, 0.1)',
          marginRight:'1%',
          marginBottom:'15px'
        }} >
          <Table
            responsive={true}
            borderless
            className={styleImmobilizeTabs.immobilizeTabTable}
          >
            <thead>
              <tr className="th-border-bottom position-relative">
                <th className="ps-2 text-nowrap">
                  <span className="fw500">Vehicle No.</span>
                </th>
                <th className="ps-2 text-nowrap">
                  <span className="fw500"> OEM & Model</span>
                </th>
                <th className="ps-2 text-nowrap">
                  <span className="fw500">CAN Speed</span>
                </th>
                <th className="ps-2 text-nowrap">
                  <span className="fw500">Device Speed</span>
                </th>
                <th className="ps-2 text-nowrap">
                  <span className="fw500">Device GPS</span>
                </th>
                <th className="ps-2 text-nowrap">
                  <span className="fw500">Status</span>
                </th>
                <th className="ps-2 text-nowrap">
                  <span className="fw500">Non Com Issue</span>
                </th>
                <th className="ps-2 text-nowrap">
                  <span className="fw500">Action</span>
                </th>
                <th className="ps-2 text-nowrap">
                  <span className="fw500">Command Status</span>
                </th>
                <th className="ps-2 text-nowrap">
                  <span className="fw500">
                    Reason for <br></br> Immobilization
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {immobilizeListData?.result?.length > 0 && (
                <>
                  {immobilizeListData?.result?.map((item, index) => (
                    <DataRow
                      key={index}
                      recent={item}
                      index={index}
                      renderTooltip={renderTooltip}
                    />
                  ))}
                </>
              )}
            </tbody>
          </Table>
          <Pagination
            disabled={false}
            totalPages={Math.ceil(immobilizeListData?.total / ITEMS_PER_PAGE)}
            currentPage={currentPage}
            setPage={handlePageChange}
            data-testid="unresolved-pagination"
          />
        </div>
      ) : (
        <></>
      )}
      {!immobilizeListData?.result?.length ? (
        <NoRecordFound></NoRecordFound>
      ) : (
        <></>
      )}
      <BaseModal
        variant="immobilize"
        isOpen={immobilizeModal}
        onClose={handleCloseImmobilize}
        title="Reason for Immobilization "
      >
        <SingleSelect
          placeholder="Select Reason"
          placeholderColor="#10204B"
          placeholderOnError=""
          webkitScrollbarWidth="5px"
          singleValueColor="#10204B"
          valueContainerJustifyContent="start"
          valueContainerWidthInPx="350px"
          valueContainerMaxWidthInPx="350px"
          optionPosition="ps-2 justify-content-start"
          valueContainerPadding="10px 30px 7px 15px"
          hoverBackgroundColor='rgba(134, 25, 228, 0.2)'
          hoverWidth=" 357px"
          hoverMargin="0 20px 0 10px;"
          hoverBorderRadius="5px"
          hoverpadding="10px 1px"
          maxMenuHeight={140}
          customBackgroundColor="#FFFFFF"
          data-testid="fence-labelowner-select"
          IndicatorsContainerBorderright="1px solid rgba(151, 151, 151, 0.39)"
          IndicatorsContainerBorderbottom="1px solid rgba(151, 151, 151, 0.39)"
          IndicatorsContainerBorderTop="1px solid rgba(151, 151, 151, 0.39)"
          IndicatorsContainerBorderRadius="5px"
          valueContainerBorderleft="1px solid rgba(151, 151, 151, 0.39)"
          valueContainerBorderbottom="1px solid rgba(151, 151, 151, 0.39)"
          valueContainerBorderTop="1px solid rgba(151, 151, 151, 0.39)"
          valueContainerborderTopLeftRadius="5px"
          valueContainerborderBottomLeftRadius="5px"
          IndicatorsContainerborderTopRightRadius="5px"
          IndicatorsContainerborderBottomRightRadius="5px"
          menuMaxheight='198px'
          options={immobilizeReasonDataList}
          selectedOptions={selectedReasonImmobilize}
          onSelectHandler={(value) => {
            setSelectedReasonImmobilize(value);
            onSelectionChangeOther(value);
          }}
        />
        {showInputField && (
          <textarea
            className={styleImmobilizeTabs.reasonOtherTextarea}
            type="text"
            onChange={handleChangeReasonImmobilize}
            value={reasonOtherInput}
          />
        )}
        <div className={!selectedReasonImmobilize?styleImmobilizeTabs.immobilizeReasonContainer:''}>
          <button
            className={styleImmobilizeTabs.immobilizeReasonBtn}
            onClick={handlereasonImmobilizeUpdate}
          >
            Immobilize
          </button>
        </div>
      </BaseModal>

      {showPopup && (
        <div id="popup1" className={`popup ${showPopup ? "open" : ""}`}>
          <div
            className="popup-overlay"
            data-testid="unresolved-gps-dialog-toggle"
            onClick={togglePopup}
          ></div>
          <div className="popup-content">
            <MapAdddressByLocation
              isOpen={showPopup}
              toggleModal={togglePopup}
              CoOrdinates={coordinate}
              data-testid="unresolved-gps-dialog"
            />
          </div>
        </div>
      )}

      <Loader isLoading={isLoading} />
    </>
  );
};

ImmobilizeTab.propTypes = {
  subscribedByCI: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

const mapStateToProps = (state) => ({
  subscribedByCI: state.vehicle.subscribedVehiclesByCI,
  immobilizeListData: state.Immobilize.immobilizeListData,
});
export default connect(mapStateToProps, {
  fetchImmobilize,
  ExportImmobilize,
  fetchReasonImmobilize,
})(ImmobilizeTab);